export default {
	init() {
		document.querySelectorAll('.wp-block-image img').forEach(image => {
			const container = image.closest('.wp-block-image')
			if (!container) return
	
			const description = image.dataset.description || false
			if (!description) return

			const wrapper = document.createElement('div')
			wrapper.className = 'wp-block-image-wrapper'

			const overlay = document.createElement('div')
			overlay.className = 'overlay'
	
			const svgIcon = `
				<svg xmlns="http://www.w3.org/2000/svg" width="13.714" height="12" viewBox="0 0 13.714 12"><path fill="#ffffff" d="M13.714,35v7.714A1.286,1.286,0,0,1,12.429,44H1.286A1.286,1.286,0,0,1,0,42.714V35a1.286,1.286,0,0,1,1.286-1.286H3.643l.329-.881A1.284,1.284,0,0,1,5.175,32H8.537a1.284,1.284,0,0,1,1.2.833l.332.881h2.357A1.286,1.286,0,0,1,13.714,35Zm-3.643,3.857a3.214,3.214,0,1,0-3.214,3.214A3.217,3.217,0,0,0,10.071,38.857Zm-.857,0A2.357,2.357,0,1,1,6.857,36.5,2.361,2.361,0,0,1,9.214,38.857Z" transform="translate(0 -32)"/></svg>
				`
	
			overlay.innerHTML = `<div class="overlay__author">${description}</div>${svgIcon}`
			
			wrapper.appendChild(image.cloneNode(true))
			wrapper.appendChild(overlay)
			image.replaceWith(wrapper)
		})
	}
};
